import { Action } from "redux";

export const WFS_3D_LAYER_LOADED = "WFS_3D_LAYER_LOADED";

export const wfs3dLayerLoadedAction = (): Action => {
    return {
        type: WFS_3D_LAYER_LOADED,
    };
};
